var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcComplete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .icon-complete {\n    fill: #35A211;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-complete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 15.5C7.9 17.6 7.9 18.3 5.3 18.1 4.4 14.7 3.2 11.4 0 9.3 1.2 8.3 2.7 8 3.9 8.8 5 9.6 5.9 10.6 7 11.6 10.2 5.7 15 1.4 22 0 15.3 3.3 11.7 9.1 8.8 15.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplete);
export default __webpack_public_path__ + "static/media/icComplete.e20971854827afea0e6092725fa23330.svg";
export { ForwardRef as ReactComponent };